import './SessionStatusScreen.css'

function WeakSignalIcon() {
	return (
		<svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
			<path d="M2 8.5a16 16 0 0 1 20 0" opacity="0.3" />
			<path d="M5 12a11 11 0 0 1 14 0" opacity="0.6" />
			<path d="M8.5 15.5a6 6 0 0 1 7 0" />
			<circle cx="12" cy="19" r="1" fill="currentColor" stroke="none" />
			<path d="M3 3l18 18" />
		</svg>
	)
}

function SessionStatusScreen({ isRetrying, hasFailed, onRetry }:
	{ isRetrying: boolean, hasFailed: boolean, onRetry: () => void }) {

	if (hasFailed) {
		return (
			<div className="SessionStatusScreen">
				<WeakSignalIcon />
				<h2>No pudimos cargar tus datos</h2>
				<p>
					Revisa tu conexión a internet e intenta nuevamente.
					Si el problema continúa, contacta a tu colegio.
				</p>
				<button type="button" onClick={onRetry}>Reintentar</button>
			</div>
		)
	}

	if (isRetrying) {
		return (
			<div className="SessionStatusScreen">
				<WeakSignalIcon />
				<h2>Reconectando...</h2>
				<p>Tu conexión está lenta, seguimos intentando.</p>
			</div>
		)
	}

	return (
		<div className="SessionStatusScreen">
			<h2>Cargando.....</h2>
		</div>
	)
}

export default SessionStatusScreen
